<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g fill-rule="evenodd"><g opacity=".75"><path d="M4 0v4H0V0h4Zm6 0v4H6V0h4Zm6 0v4h-4V0h4Z" opacity=".6" fill="currentColor"/><path d="M4 6v4H0V6h4Zm6 0v4H6V6h4Zm6 0v4h-4V6h4Z" fill="currentColor"/></g><path d="M4 12v4H0v-4h4Zm6 0v4H6v-4h4Zm6 0v4h-4v-4h4Z" fill="currentColor"/></g></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-prodoffering05',
});
</script>
